import { SellerItemUi } from '@/components/Seller/Table/SellerUi';
import { SellerResponse } from '@/data/api/model/sellers/SellersDto';

export const sellerResponseToSellerItemUi = (
  item: SellerResponse
): SellerItemUi => {
  return {
    id: item.business_id,
    sellerName: item.account_name,
    accountName: item.business_name,
    email: item.email,
    phone: item.phone,
  };
};
